export default __webpack_public_path__ + "static/media/nike_dunks_logo.8b1a69b5.png";